import IconGitHub from '@/components/assets/icon_github.svg'
import { FormControl, FormField, FormItem } from '@/components/ui/form'
import ViverseInput from '@/components/ViverseInput'
import { WorldSettingsFormValues } from '@/hooks/useWorldSettingsFormSchema'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { useFormContext } from 'react-hook-form'

export type WorldSettingCodeAndCollabTabProps = {
  handleGithubUrlChange: (url: string) => void
}
const GITHUB_PREFIX = 'https://github.com/'

const WorldSettingCodeAndCollabTab = () => {
  const t = useTranslations()
  const form = useFormContext<WorldSettingsFormValues>()
  const [isFocused, setIsFocused] = useState(false)

  return (
    <div className="flex w-full flex-col">
      <div className="md:subheader-1 subheader-2 mb-2 md:mb-4">
        {t('profile-page.my-worlds-card-settings-github')}
      </div>
      <p className="text-vive-primary-30 body-2">
        {t('profile-page.my-worlds-card-settings-github-caption')}
      </p>
      <div className="mt-2 flex w-full flex-col md:mt-4">
        <FormField
          control={form.control}
          name="githubUrl"
          render={({ field }) => (
            <FormItem className="flex w-full flex-row">
              <div className="mr-2 mb-0 flex shrink-0 items-center md:mr-4">
                <IconGitHub className="h-6 w-6 md:h-7 md:w-7" />
              </div>
              <FormItem
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                className="group bg-vive-primary-70/50 focus-within:hover:bg-vive-primary-70/50 hover:bg-vive-primary-40/50 focus-within:border-vive-brand-50 box-content flex h-[34px] w-full flex-row justify-start rounded-md border-2 border-transparent transition-all md:h-12"
              >
                <p
                  className={cn(
                    'mb-0 flex items-center py-2 pr-0 pl-4 text-[12px] md:py-3 md:pl-5 md:text-base',
                    isFocused
                      ? 'text-vive-primary-30'
                      : 'text-vive-primary-30 group-hover:text-vive-white',
                  )}
                >
                  {GITHUB_PREFIX}
                </p>
                <FormControl>
                  <ViverseInput
                    className={cn(
                      'bg-transparent py-2 pr-4 pl-0 text-[12px] md:py-3 md:pr-5 md:text-base',
                      isFocused
                        ? 'text-vive-primary-30'
                        : 'text-vive-primary-30 group-hover:text-vive-white',
                    )}
                    containerClassName="bg-transparent border-none"
                    value={field.value?.replace(GITHUB_PREFIX, '') || ''}
                    onChange={(e) => {
                      const userInput = e.target.value
                      const fullUrl = userInput ? GITHUB_PREFIX + userInput : ''
                      field.onChange(fullUrl)
                      form.trigger('githubUrl')
                    }}
                  />
                </FormControl>
              </FormItem>
            </FormItem>
          )}
        />
      </div>
    </div>
  )
}
export default WorldSettingCodeAndCollabTab
